import { memo } from 'react';
import classnames from 'classnames';
import { ColorPickerRow } from '../../../../ui';
import {
  ColorGroupWrapper,
  ColorGroupFields,
  ColorGroupFieldsLabel,
  ColorGroupInput,
  DragIcon,
} from './color-group-setting.styles';
import { FormInput } from '../../../../components/ui/form-input';
import { messages } from '../../../../i18n';
import { SugarIcon } from '../../../../icons/sugar-icon';
import { useColorGroupSetting } from './color-group-setting.hook';
import {
  FieldsWidget,
  FieldsWidgetContextProvider,
} from '../../../fields-widget';
import DragIconSVG from '../../../../../images/sdd/icon_drag.svg';
import { IColorGroup, IUseColorGroup } from './color-group-setting.interfaces';
import { useColorGroupDnd } from './color-group-dnd.hook';

export const ColorGroupSetting = memo<IColorGroup>(
  ({ item, vizId, customColors, toIndex }) => {
    const {
      onColorGroupChange,
      selColor,
      onLegendLabelChange,
      onFieldsSelectionSave,
      removeColorGroup,
      colorGroupLabel,
    }: IUseColorGroup = useColorGroupSetting({
      item,
      vizId,
      customColors,
    });

    const { dropRef, dragRef, dndClasses } = useColorGroupDnd({
      item,
      vizId,
      toIndex,
    });

    return (
      <ColorGroupWrapper
        className={classnames('color-group', dndClasses)}
        ref={dropRef}
      >
        <ColorGroupInput>
          <DragIcon ref={dragRef}>
            <DragIconSVG aria-label={messages.close} />
          </DragIcon>
          <FormInput
            className={`name-input`}
            placeholder={messages.formatting.legendItemLabel}
            value={colorGroupLabel}
            sx={{ '&.MuiInputBase-root': { px: 1 } }}
            onChange={onLegendLabelChange}
          />
          <SugarIcon
            icon='close'
            size={12}
            aria-label={messages.close}
            onClick={removeColorGroup}
          />
        </ColorGroupInput>
        <ColorPickerRow
          key={item.label}
          label={messages.layoutPanel.colorLabel}
          selectedColor={selColor}
          onSelect={onColorGroupChange}
          isColorGroup
        />
        <ColorGroupFields>
          <ColorGroupFieldsLabel>
            {messages.layoutPanel.fieldsLabel}
          </ColorGroupFieldsLabel>
          <FieldsWidgetContextProvider legendGroupDataId={item.id}>
            <FieldsWidget
              onSave={onFieldsSelectionSave}
              headerSx={{
                width: '100%',
                height: '28px',
              }}
              widgetWidth={'70%'}
              widgetType={'fields'}
              disableSelectAll={false}
              placeholder={messages.formatting.emptyFields}
            />
          </FieldsWidgetContextProvider>
        </ColorGroupFields>
      </ColorGroupWrapper>
    );
  },
);
